import React, { Component } from 'react';
import MainNav from "../components/Nav";
import { Nav } from 'react-bootstrap';
import Footer from "../components/Footer";
import Intro from "../components/Intro";
import Cwe from "../components/Projects/cwe";
// import Mcpbuilder from "../components/Projects/mcpbuilder";
import Curriculum from "../components/Projects/curriculum";
// import Video from "../components/Projects/vimeo_video";
import LegacyLink from '../components/Projects/legacy_link';
import LegacyPostWizard from '../components/Projects/legacy_post_wizard';
import ObservationsDashboard from '../components/Projects/observations_dashboard';
import LeadIdentity from '../components/Projects/lead-identity';
import "./style.css"

const PROJECTS = [
    { id: 'legacy-link', label: 'Legacy Link Intranet Platform', meta: 'Legacy Traditional Schools (Vertex Education) · PHP / JavaScript / REST API' },
    { id: 'lead-identity', label: 'Lead Journey & Identity Platform', meta: 'Legacy Traditional Schools (Vertex Education) · PHP / HubSpot / GA4' },
    { id: 'legacy-post-wizard', label: 'React Post Wizard', meta: 'Legacy Traditional Schools (Vertex Education) · React / WordPress' },
    { id: 'observations-dashboard', label: 'Employee Observations Dashboard', meta: 'Legacy Traditional Schools (Vertex Education) · PHP / WordPress' },
    { id: 'cwe', label: 'Center for Writing Excellence', meta: 'University of Phoenix · PHP / API Integration' },
    { id: 'curriculum', label: 'Curriculum Hub', meta: 'University of Phoenix · WordPress / REST API' },
    // { id: 'mcp', label: 'MCP Builder', meta: 'Quicken · JavaScript / HTML Generator' },
    // { id: 'video', label: 'Video Player & Upload Tool', meta: 'University of Phoenix · JavaScript / Video Integration' },
];

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visibleElement: 'intro',
            projectMenuOpen: false,
        };
    }

    handleToggle = (event, targetId) => {
        event.preventDefault();
        this.setState({
            visibleElement: targetId,
            projectMenuOpen: false,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    toggleProjectMenu = () => {
        this.setState((state) => ({ projectMenuOpen: !state.projectMenuOpen }));
    };

    render() {
        const { visibleElement, projectMenuOpen } = this.state;

        return (
            <div>
                <div className="vertical-center">
                    <div className='container'>
                        <div>
                            <MainNav />
                            <div className="inner-container">
                                <div className='row'>
                                    <div className='col-lg-8 order-2 order-lg-1'>
                                        <div id='intro' style={{ display: visibleElement === 'intro' ? 'block' : 'none' }}><Intro /></div>
                                        <div id='cwe' style={{ display: visibleElement === 'cwe' ? 'block' : 'none' }}><Cwe onNavigate={this.handleToggle} /></div>
                                        <div id='curriculum' style={{ display: visibleElement === 'curriculum' ? 'block' : 'none' }}><Curriculum onNavigate={this.handleToggle} /></div>
                                        {/* <div id='mcp' style={{ display: visibleElement === 'mcp' ? 'block' : 'none' }}><Mcpbuilder /></div> */}
                                        <div id='legacy-link' style={{ display: visibleElement === 'legacy-link' ? 'block' : 'none' }}><LegacyLink onNavigate={this.handleToggle} /></div>
                                        <div id='legacy-post-wizard' style={{ display: visibleElement === 'legacy-post-wizard' ? 'block' : 'none' }}><LegacyPostWizard onNavigate={this.handleToggle} /></div>
                                        <div id='observations-dashboard' style={{ display: visibleElement === 'observations-dashboard' ? 'block' : 'none' }}><ObservationsDashboard onNavigate={this.handleToggle} /></div>
                                        <div id='lead-identity' style={{ display: visibleElement === 'lead-identity' ? 'block' : 'none' }}><LeadIdentity onNavigate={this.handleToggle} /></div>
                                        {/* <div id='video' style={{ display: visibleElement === 'video' ? 'block' : 'none' }}><Video /></div> */}
                                    </div>
                                    <div className='col-lg-4 order-1 order-lg-2 projects-sidebar'>
                                        <div className={`projects-menu${projectMenuOpen ? ' is-open' : ''}`}>
                                            <button
                                                type="button"
                                                className="projects-menu-toggle"
                                                onClick={this.toggleProjectMenu}
                                                aria-expanded={projectMenuOpen}
                                                aria-controls="project-menu-list"
                                            >
                                                <span>Selected Projects</span>
                                                <i className={`fa-solid fa-chevron-${projectMenuOpen ? 'up' : 'down'}`}></i>
                                            </button>
                                            <h2 className="projects-menu-heading">Selected Projects</h2>
                                            <div className="project-wrapper" id="project-menu-list">
                                                <Nav className="" id="navbar-link">
                                                    <ul>
                                                        {PROJECTS.map((project) => (
                                                            <Nav.Link
                                                                key={project.id}
                                                                className={`main-link${visibleElement === project.id ? ' is-active' : ''}`}
                                                                href="#"
                                                                aria-current={visibleElement === project.id ? 'page' : undefined}
                                                                onClick={(event) => this.handleToggle(event, project.id)}
                                                            >
                                                                {project.label}
                                                                {project.meta && (
                                                                    <span className="project-link-meta">{project.meta}</span>
                                                                )}
                                                            </Nav.Link>
                                                        ))}
                                                    </ul>
                                                </Nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Main;
